import { useNavigate } from 'react-router';
import { Client } from 'api/getClient.ts';
import { ClientApplication } from 'hooks/webapi/client/useApplicationQuery';
import {
  DOWNSALE,
  UPSALE,
  REJECTED_OFFER,
  MANUAL_REVIEW,
  MANUAL_PSD2_BANKS,
  CONSENT,
  APPROVED,
  ADJUST_INCOME,
  PHONE_VERIFICATION,
  FINANCE,
} from 'Router/routes';
import { shouldNavigateToFinance } from 'utils/navigation';

function resolveRoute(
  application: ClientApplication,
  client?: Client,
): string | null {
  const { resolution, resolutionDetail, resolutionMessage, confirmed } =
    application;

  if (resolution === 'REJECTED') {
    if (resolutionDetail === 'UPSALE_OFFER') return UPSALE;
    if (resolutionDetail === 'NEW_OFFER') return DOWNSALE;
    return REJECTED_OFFER;
  }

  if (resolution === 'MANUAL') {
    if (resolutionDetail === 'INSUFFICIENT_PSD2_INCOME') return ADJUST_INCOME;
    if (resolutionMessage === 'ASK_FOR_DOCUMENTS') return MANUAL_PSD2_BANKS;
    return MANUAL_REVIEW;
  }

  if (resolution === 'APPROVED') {
    return confirmed ? APPROVED : CONSENT;
  }

  // check Client if needed (welcome back flow)
  if (client) {
    if (!client.mobilePhoneVerified) return PHONE_VERIFICATION;
    if (shouldNavigateToFinance(client)) return FINANCE;
  }

  return null;
}

function useNavigateByApplication() {
  const navigate = useNavigate();

  const navigateNext = (
    application: ClientApplication,
    client?: Client,
  ): boolean => {
    const route = resolveRoute(application, client);

    if (route) {
      navigate(route);
      return true;
    }

    return false;
  };

  return { navigateNext };
}

export default useNavigateByApplication;
